<template>
  <header class="main-header">
    <van-icon class="back goBack" size="20px" name="arrow-left" @click="goBack($route.meta.backPath)" v-if="$route.meta.hasBack"/>
    <span>{{$route.meta.title}}</span>
    <van-icon v-if="hasSearch" name="search" @click="showSearch = !showSearch"/>
    <el-collapse-transition>git
      <van-search
        class="search-box"
        v-show="showSearch"
        v-model="inputValue"
        placeholder="请输入名称搜索"
        show-action
        shape="round"
      >
        <div slot="action">
          <van-button size="mini" @click="cancel">取消</van-button>
          <van-button type="primary" size="mini" @click="comfirm">确定</van-button>
        </div>
      </van-search>
    </el-collapse-transition>
    <div class="more" v-if="$route.meta.hasMore&&detail" @click.self="isCollapse=!isCollapse">
      更多
      <ul class="submenu" v-if="isCollapse&&$route.name==='CheckDetail'">
        <router-link tag="li" v-for="item in menuList" :key="item.name" :to="item.to">{{item.name}}</router-link>
      </ul>
      <ul class="submenu" v-else-if="isCollapse&&$route.name==='CollectDetail'">
        <li v-for="(item,index) in menuList2" :key="item.name" @click="filterCondition(item.value,index)" :class="{'activeTab':index===currentIdx}">{{item.name}}</li>
      </ul>
    </div>
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: "headerTitle",
  props: {
    hasSearch: {
      type: Boolean,
      default: false
    },
    detail:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      inputValue: "",
      showSearch: false,
      isCollapse: false,
      menuList: [
        { name: "全部", to: "/map?classify=0" },
        { name: "我采集的", to: "/map?classify=1" },
        { name: "附近", to: "/map?classify=2" },
      ],
      menuList2:[
        {name:'全部',value:null},
        {name:'通过',value:2},
        {name:'待审核',value:0},
        {name:'驳回',value:1},
      ],
      currentIdx:0
    };
  },
  created() {
  },
  methods: {
    comfirm() {
      this.$emit("onsearch", this.inputValue);
      this.showSearch = false;
    },
    cancel() {
      this.inputValue = "";
      this.showSearch = false;
    },
    filterCondition(val,index){
      this.currentIdx=index
      this.isCollapse=false
      eventBus.$emit('filterCondition',val)
    },
    searchStaff(){
     this.$emit("search");
    },
    goBack(path){
      if(path){
        this.$router.push(path)
      }else{
        this.$router.go(-1)
      }
      
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.goBack{
  position: absolute;
 left: 0;
 top: 0;
  background-size: 40px;
  width:40px;
  height: 40px;
}
.main-header {
  .goBack{
    width: 40px;
    height: 40px;
    position: absolute;
    left:0;
    top:0;
    background-size: cover;
  }
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: $maincolor;
  text-align: center;
  color: #ffffff;
  > span {
    line-height: 40px;
  }
  .van-icon {
    position: absolute;
    top: 0;
    right: 0;
    height: 40px;
    width: 40px;
    font-size: 20px;
    line-height: 40px;
  }
  .search-box {
    box-shadow: 0px 2px 2px 0px rgba(170, 170, 170, 0.1);
  }
  .more {
    position: absolute;
    right: 12px;
    top: 10px;
  }
  .submenu {
    right: -8px;
    position: absolute;
    top: 38px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    box-shadow: 0 5px 5px 0 rgba(174, 174, 174, 0.35);
    border-radius: 4px;
    font-size: 14px;
    width: 122px;
    color: #333;
    z-index: 999;
    li {
      height: 50px;
      line-height: 50px;
    }
  }
  .activeTab{
    color: $maincolor;
  }
}
</style>

<style lang="scss">
.main-header + * {
  margin-top: -40px;
  padding-top: 80px;
}
</style>






// WEBPACK FOOTER //
// src/base/headerTitle.vue